import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Target, Zap, TrendingUp, Users, Search, Rocket } from 'lucide-react';

export default function SolutionGTM() {
  return (
    <SubpageTemplate 
      title="GTM Strategy"
      subtitle="Launch Intelligence"
      description="Synthesize your market entry. From target audience mapping to viral distribution assets, we provide the intelligence you need to win."
      icon={Target}
      features={[
        {
          title: "Market Mapping",
          description: "Identify high-intent user segments and tailor your messaging for maximum impact.",
          icon: Search
        },
        {
          title: "Viral Assets",
          description: "Automated generation of platform-specific launch content that actually converts.",
          icon: Rocket
        },
        {
          title: "Growth Loops",
          description: "Built-in mechanics to turn initial users into long-term advocates.",
          icon: TrendingUp
        }
      ]}
    />
  );
}
